
import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3F';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;